import { useEffect, useState } from "react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { Box, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, SelectProps, TextField } from "@mui/material"
import useAuth from "../context/AuthProvider"
import { config } from "../Constants"
import { ClientBillingReportModel, ClientBillingReportModel_Resp } from "../models/ClientBillingReportModel"
import { ClientBillingReportMonthlyList } from "../components/Lists/ClientBillingReportMonthlyList"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ClientBillingReportAnnualList } from "../components/Lists/ClientBillingReportAnnualList"
import React from "react"
import Swal from "sweetalert2"
import { padding } from "@mui/system"
import { months } from "moment"
import { apiClient } from "../helper/api"
import { initPartner, PartnerType } from "../models/PartnersModel"

const keyNames: (keyof ClientBillingReportModel)[] = [
  'stateId', 'reportName', 'period', 'license', 'dateFinal', 'isPaymentRequired', 'paymentType', 'isReportRequired', 'licenseMain', 'premiumReport', 'feeDue'
]

export const MonthEndBillingModule = () => {

  const { user } = useAuth()
  const token = user?.token
  const [loading, setloading] = useState(false)

  const initValue: ClientBillingReportModel_Resp = {
    items: [],
    totalCount: 0,
    pageCount: 0,
    pageSize: 25,
    currentPage: 0,
  }
  const [itemList, setItemList] = useState<ClientBillingReportModel[]>(initValue.items)
  const [currentPage, setCurrentPage] = useState(initValue.currentPage)
  const [pageSize, setPageSize] = useState(initValue.pageSize)
  
  const combineFilters = (filterModel: any) => {
    if (!filterModel?.items || filterModel.items.length === 0) {
      return { filters: [], firstFilter: { fieldName: '', value: '', operator: '' } }
    }
  
    // Get ALL active filters
    const activeFilters = filterModel.items.filter((item: any) => 
      item.columnField && 
      item.columnField.trim() !== '' && 
      item.value !== undefined && 
      item.value !== null && 
      item.value.toString().trim() !== '' &&
      item.operatorValue && 
      item.operatorValue.trim() !== ''
    );
  
    if (activeFilters.length === 0) {
      return { filters: [], firstFilter: { fieldName: '', value: '', operator: '' } }
    }
  
    console.log('Using filters:', activeFilters); // DEBUG
  
    const processedFilters = activeFilters.map((filter: any) => ({
      fieldName: filter.columnField || '',
      value: filter.value.toString() || '',
      operator: filter.operatorValue || ''
    }));

    return {
      filters: processedFilters,
      firstFilter: processedFilters[0] || { fieldName: '', value: '', operator: '' }
    };
  }

  const fetchData = (action: string, pageSize: number, currentPage: number, period: string, PartnerId: string, month: string, year: string, filterModel: any, field: string, sort: string) => {
    const params = new URLSearchParams();

     // Combine multiple filters
  const combinedFilters = combineFilters(filterModel)
  console.log('Sending filters:', combinedFilters); // DEBUG

    params.append('pageSize', pageSize.toString() || '');
    params.append('currentPage', currentPage.toString() || '');
    params.append('period', period || '');
    params.append('partnerId', PartnerId || '');
    if (period === "Monthly") {
      params.append('month', month || '1');
    } else {
      params.append('month', '0');
    }
    params.append('year', year || '');
    
    // Handle multiple filters
    if (combinedFilters.filters.length > 0) {
      // Send all filters as JSON in the filters parameter
      params.append('filters', JSON.stringify(combinedFilters.filters));
      
      // For backward compatibility, also send the first filter as individual params
      params.append('fieldName', combinedFilters.firstFilter.fieldName);
      params.append('value', combinedFilters.firstFilter.value);
      params.append('operator', combinedFilters.firstFilter.operator);
    } else {
      params.append('fieldName', '');
      params.append('value', '');
      params.append('operator', '');
    }
    
    params.append('field', field || '');
    params.append('sort', sort || '');

    apiClient(`/MonthEndBilling/get-month-end-billing?${params.toString()}`, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    }).then(responseJson => {
      console.log('API Response:', responseJson); // DEBUG
      if (!responseJson.data?.items?.length) {
        // Do something if no items.
        setItemList([])
        return
      }
      setItemList(responseJson.data.items)
    }).finally(() => {
      setloading(false)
    });
  };
  const [selectedValue, setSelectedValue] = useState<string>("Monthly");

  const [selectMonthValue, setSelectedMonthValue] = useState<string>("1");
  const [sortModel, setSortModel] = useState([{ field: "", sort: "" }]);
  const [filterModel, setFilterModel] = useState({ items: [{ columnField: "", value: "", operatorValue: "" }] });

  const [yearValue, setYearValue] = useState(new Date().getFullYear().toString());

  const deleteOTRData = async (items: ClientBillingReportModel[]) => {
    const payload = {
      clientBillingReports: items.map(item => ({
        CustomerPolicyId: item.customerPolicyId,    // uppercase key
        PolicyStatus: item.filed       // match your new validator key
      }))
    };
    // Send the array of items in one request
    const response = await apiClient(`/MonthEndBilling/delete-Client-Billing-Report`, {
      method: "POST",
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }),
      // body: JSON.stringify(items), // Send the array of items
      body: JSON.stringify(payload),
    });

    if (!response) return
    console.log("Delete response:", response);
    setItemList([]);
    // reloadData();
    return response;
  };

  const getCBR = async () => {

    //fetchData('getMonthEndBilling', 50, 1, "Monthly", "0", selectMonthValue, yearValue, filterModel['items'][0]['columnField'], filterModel['items'][0]['value'], sortModel[0]['field'], sortModel[0]['sort'], filterModel['items'][0]['operatorValue']);
    fetchData('getMonthEndBilling', 50, 1, "Monthly", "0", selectMonthValue, yearValue, filterModel, sortModel[0]['field'], sortModel[0]['sort']);
  }

  useEffect(() => {
    getCBR()
    fetchCustomer()
  }, [])

  const handlePageChange = (val: number) => {
    setCurrentPage(val)
  }
  const handlePageSizeChange = (val: number) => {
    if (val <= 0) return
    setPageSize(val)
  }

  const handleRemoveItems = async (values: ClientBillingReportModel[]) => {
    console.log({ values })
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      showCancelButton: true,
      confirmButtonColor: '#02A4E3',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Delete',
      customClass: {
        confirmButton: 'btn-radius',
        cancelButton: 'btn-radius',
        popup: 'card-radius'
      }
    })

    if (result.isConfirmed) {
      await deleteOTRData(values)
      getCBR()
    }
  }

  const handleChange = (event: SelectChangeEvent<string>) => {

    setSelectedValue(event.target.value);
    fetchData("getMonthEndBilling", 50, 1, event.target.value, selPartnerId, selectMonthValue, yearValue, filterModel, sortModel[0]['field'], sortModel[0]['sort']);

  };

  const handleMonthChange = (event: SelectChangeEvent<string>) => {

    setSelectedMonthValue(event.target.value);
    fetchData("getMonthEndBilling", 50, 1, selectedValue, selPartnerId, event.target.value, yearValue, filterModel, sortModel[0]['field'], sortModel[0]['sort']);
  };

  const handleYearChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    setYearValue(event.target.value);
    const currentYear = new Date().getFullYear();
    let value = parseInt(event.target.value, 10);

    if (value > 1900 && value <= currentYear) {
      fetchData("getMonthEndBilling", 50, 1, selectedValue, selPartnerId, selectMonthValue, event.target.value, filterModel, sortModel[0]['field'], sortModel[0]['sort']);
    }
  };


  const handleSortChange = (newSortModel: any) => {
    setSortModel(newSortModel)
    console.log('filterModel', filterModel);
    console.log('newSortModel', newSortModel);
    fetchData("getMonthEndBilling", 50, 1, selectedValue, selPartnerId, selectMonthValue, yearValue, filterModel, newSortModel[0]['field'], newSortModel[0]['sort']);
  };

  const handleFilterChange = (newFilterModel: any) => {
    setFilterModel(newFilterModel)
      fetchData("getMonthEndBilling", 50, 1, selectedValue, selPartnerId, selectMonthValue, yearValue, newFilterModel, sortModel[0]['field'], sortModel[0]['sort']);
  };

  const [customers, setCustomers] = useState<PartnerType[]>([initPartner]);
  const fetchCustomer = () => {
    apiClient("/Partners/getPartners", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((responseJson) => {
        if (!responseJson) return
        // Do something with the response
        setCustomers(responseJson.data);
      })
  };

  // const [selPartnerId, setSelPartnerId] = React.useState<string>('0')
  const [selPartner, setSelPartner] = useState<PartnerType>(initPartner)
  const selPartnerId = selPartner.partnersId.toString()

  const FMSelectCustomCustomer: React.FC<SelectProps> = ({ variant, ...props }) => {
    const handleChangePartner = (event: SelectChangeEvent) => {
      const val = event.target.value.toString()
      fetchData("getMonthEndBilling", 50, 1, selectedValue, val, selectMonthValue, yearValue, filterModel, sortModel[0]['field'], sortModel[0]['sort']);
      const sel = customers.find(c => c.partnersId.toString() === val) ?? initPartner
      setSelPartner(sel)
      console.log({ sel })
    };
    return (
      <div>
        <FormControl fullWidth>
          <Select
            onChange={handleChangePartner}
            value={selPartnerId}
            id="test-select-label"
            autoWidth
            size="small"
            label={null}
            className="border-round custom-menu-item"
            IconComponent={ExpandMoreIcon}
            displayEmpty
          >
            <MenuItem key={""} value={"0"}>All</MenuItem>
            {customers?.map((item, key) => (
              <MenuItem
                key={key}
                className="custom-menu-item"
                value={item.partnersId}
              >
                {item.customerName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ width: '100%', height: '100%' }}>
        <div className="card-title d-flex col-lg-12">
          <span className="col-lg-5">Month End Billing Report</span>
          <div className="col-lg-2">
            {user?.userRoles.split(",").includes("Super Admin") && (<FMSelectCustomCustomer name="customer" />
            )}
          </div>
          <FormControl fullWidth className="main-form-2 ms-3 d-flex">
            <InputLabel className="" id="month-Label">Select Month</InputLabel>
            <Select
              labelId="month-Label"
              IconComponent={ExpandMoreIcon}
              label="Select Month"
              value={selectMonthValue}
              onChange={handleMonthChange}
            >
              <MenuItem value={1}>January</MenuItem>
              <MenuItem value={2}>February</MenuItem>
              <MenuItem value={3}>March</MenuItem>
              <MenuItem value={4}>April</MenuItem>
              <MenuItem value={5}>May</MenuItem>
              <MenuItem value={6}>June</MenuItem>
              <MenuItem value={7}>July</MenuItem>
              <MenuItem value={8}>August</MenuItem>
              <MenuItem value={9}>September</MenuItem>
              <MenuItem value={10}>October</MenuItem>
              <MenuItem value={11}>November</MenuItem>
              <MenuItem value={12}>December</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth className="main-form-3 ms-3 d-flex">
            <TextField
              label="Year"
              type="number"
              value={yearValue}
              onChange={handleYearChange}
              defaultValue={new Date().getFullYear()}
              InputProps={{
                style: { height: '2.8rem' } // Change font size here for input text
              }}
            />
          </FormControl>
        </div>
        <Box
          overflow={"scroll"}
          sx={{
            height: "calc(100% - 60px)",
            width: "100%"
          }}
        >
          <ClientBillingReportMonthlyList
            listData={itemList}
            onRemoveItems={handleRemoveItems}
            setItemList={setItemList}
            selectedMonth={Number(selectMonthValue)}
            handleFilterChange={handleFilterChange}
            handleSortChange={handleSortChange}
            selectedPeriod={selectedValue}
            selectedYear={yearValue}
            selectedPartner={selPartner}
          />
        </Box>
      </Box>
    </LocalizationProvider>
  )
}